<app-header></app-header>
<app-botao-chat></app-botao-chat>
@if (showAlertAlterarEndereco) {
  <app-alert-alterar-endereco [alertAlterarEndereco]="showAlertAlterarEndereco"
    [enderecoSelecionado]="enderecoSelecionado" [idEmpresa]="idEmpresaEndFaturamento" [idPedidoAtivo]="idPedidoAtivo"
    (alertAlterarEnderecoFechou)="eventoAlertAlterarEndereco($event)">
  </app-alert-alterar-endereco>
}
<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<alert-confirmar-pedido [showAlertConfirmaPedido]="showAlertConfirmaPedido" sourceScreen="fazer-pedido-integral:deseja-concluir-pedido" (confirmarPedido)="onSubmit($event)">
</alert-confirmar-pedido>
<app-alert-erro-customizado [alertErro]="showAlertErro" [alertErroBotao]="mensagemBotaoErroApi"
[alertErroTitulo]="tituloErroApi" [alertErroMensagem]="mensagemErroApi" (alertErroFechou)="eventoAlertErro()"></app-alert-erro-customizado>
<app-detalhes-erros-cnpj [alertDetalheErrosPedido]="alertErroPedidoCnpj"
  [detalhesErroCnpj]="detalhesErroCnpj"
  (abrirDetalheErrosPedido)="eventoAlertDetalheErrosCnpj($event)"
></app-detalhes-erros-cnpj>
<app-alert-ignorar-erros [alertIgnorarErros]="alertIgnorarErroPedido" (fecharAlertIgnorarErros)="fecharAlertIgnorarErros()" ></app-alert-ignorar-erros>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Fazer Pedido Integral</h1>
        <p class="paragrafo mb-4">Conclua seu pedido integral</p>

        @if (enderecosFaturamento?.response != null) {
          <table class="table table-hover border-bottom mt-4" aria-describedby="tabela que lista as empresas">
            <thead>
              <tr>
                <th scope="col">EMPRESA</th>
                <th scope="col">ENDEREÇO DE FATURAMENTO</th>
                <th scope="col">ERROS</th>
                <th scope="col">VALOR VALES</th>
                <th scope="col">OUTRAS COBRANÇAS</th>
                <th scope="col">VALOR TAXA</th>
                <th scope="col">VALOR DESCONTO</th>
                <th scope="col">VALOR A PAGAR</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              @for (calculo of enderecosFaturamento.response; track calculo) {
                <tr>
                  <td>
                    <p class="text-nowrap pb-0 mb-0">{{ calculo.empresa.cnpj | cnpj }}</p>
                    <p>{{ calculo.empresa.nome }}</p>
                  </td>
                  <td> {{ calculo.enderecoFaturamento.descricaoLogradouro | camelCase }}, {{ calculo.enderecoFaturamento.codigoNumero }} -
                    {{ calculo.enderecoFaturamento.codigoBairro | camelCase }}-
                    {{ calculo.enderecoFaturamento.codigoCidade | camelCase }} - {{ calculo.enderecoFaturamento.codigoEstado }} -
                  {{ calculo.enderecoFaturamento.codigoCep | camelCase }} </td>
                  <td>
                    @if (calculo.errosValidacao) {
                      <div>
                        <button
                          class="btn-icon"
                          (click)="checkStatusCnpj(calculo.empresa.id, calculo.idPedidoAtivo)"
                          title="Foram identificados erros nos dados do pedido. Você pode baixar o relatório de erros no final da página."
                          aria-label="Verificar erros de validação"
                          data-bs-toggle="tooltip"
                          data-placement="top"
                          [tag]="addTagManagerInteraction('select:icon:click', 'informativo&coluna-erros')">
                          <i class="fa fa-exclamation-circle c-warning fa-2x ms-3 icone-padrao" aria-hidden="true"></i>
                        </button>
                      </div>
                    }
                  </td>
                  <td> {{ calculo.valoresVales | currency: 'BRL' }} </td>
                  <td> {{ calculo.valoresOutrasCobrancas  | currency: 'BRL'}} </td>
                  <td> {{ calculo.valoresTaxas  | currency: 'BRL'}} </td>
                  <td> {{ calculo.valoresDescontos  | currency: 'BRL'}} </td>
                  <td> {{ calculo.valoresPagar  | currency: 'BRL'}} </td>
                  <td class="text-center">
                    <button
                      class="btn-icon"
                      (click)="abrirEdicaoEnderecoFaturamento(calculo)"
                      aria-label="Editar endereço de faturamento"
                      [tag]="addTagManagerInteraction('select:icon:click', 'editar-endereco')">
                      <i class="fa fa-pencil c-primary icone-menor" aria-hidden="true"></i>
                    </button>
                  </td>
                  <td>
                    <div>
                      <i
                        class="fa fa-info-circle c-black fa-1x icone-padrao"
                        aria-hidden="true"
                        [popover]="myPopover"
                        popoverTitle="Editar Endereços"
                        popoverPlacement="top"
                        triggers="click"
                        [outsideClick]="true"
                        [tag]="addTagManagerInteraction('select:icon:click', 'informativo&editar-o-endereco')">
                      </i>
                      <ng-template #myPopover>
                        <span class="texto-tabela">
                          Edite o endereço utilizando a ferramenta ao lado.
                        </span>
                      </ng-template>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
        <app-loading-generico [loadingGenerico]="loadingGenerico" [showOverlay]='false' message='Consultando dados de importação ...'></app-loading-generico>
        <!-- Para centralizar adiciona o justify content center nessa row -->
        @if (!loadingGenerico) {
          <app-pedido-form-fields [form]="this"></app-pedido-form-fields>
        }

        @if (!loadingGenerico) {
          <div class="container">
            @if (showBaixarRelatorio === true) {
              <div class="row">
                <div class="col-4">
                  <button class="botao-relatorio mt-2" (click)="downloadRelatorioErros()" [tag]="addTagManagerInteraction('box:button:click', 'relatorio-de-todos-os-beneficios-ignorados')">
                    <i class="fa fa-download" aria-hidden="true"></i>
                  Relatório de todos os benefícios ignorados.</button>
                </div>
                <div>
                  <i
                    class="fa fa-info-circle c-black fa-1x icone-padrao"
                    aria-hidden="true"
                    [popover]="myPopoverRelatorio"
                    popoverTitle="Relatório de benefícios ignorados"
                    popoverPlacement="top"
                    triggers="click"
                    [outsideClick]="true"
                    [tag]="addTagManagerInteraction('select:icon:click', 'informativo&relatorio-de-todos-os-beneficios-ignorados')">
                  </i>
                  <ng-template #myPopoverRelatorio>
                    <span class="texto-tabela">
                      O botão de conclusão do pedido será habilitado após download de relatório de benefícios ignorados.
                      <a style="color: red;">*</a>
                    </span>
                  </ng-template>
                </div>
              </div>
            }
            <div class="row mt-3">
              <div class="col text-center">
                <button type="button" class="botao-outline me-3 px-5" id="btnCancelarPedido" (click)='cancelarPedido()' [tag]="addTagManagerInteraction('box:button:click', 'cancelar-pedido')">CANCELAR PEDIDO</button>
                @if (!existemErros) {
                  <button type="button" class="botaoLongo text-center" id="btnConcluirSolicitacao" (click)="onConcluirPedido()" [ngClass]="{ 'disabled': erroCnpj }" [tag]="addTagManagerInteraction('box:button:click', 'concluir-solicitacao-de-pedido')">CONCLUIR SOLICITAÇÃO DE PEDIDO </button>
                }
                @if (existemErros && ignorarInconsistencias && baixouRelatorio) {
                  <button type="button" class="botaoLongo text-center" id="btnConcluirSolicitacao" (click)="onConcluirPedido()" [tag]="addTagManagerInteraction('box:button:click', 'concluir-solicitacao-de-pedido')">CONCLUIR SOLICITAÇÃO DE PEDIDO </button>
                }
                <!-- BOTÕES DESATIVADOS -->
                @if (existemErros && (!ignorarInconsistencias || !baixouRelatorio)) {
                  <button type="button" class="botaoLongo text-center disabled" id="btnConcluirSolicitacao" disabled>CONCLUIR SOLICITAÇÃO DE PEDIDO </button>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
